package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * New Zealand Flag (32x24dp)
 *
 * - ISO Alpha-2: NZ
 * - ISO Alpha-3: NZL
 * - ISO Numeric: 554
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.NewZealand: ImageVector by lazy {
    ImageVector.Builder(
        name = "New Zealand:NZ:NZL:554:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(18f)
                verticalLineToRelative(14f)
                horizontalLineToRelative(-18f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFF2E42A5))) {
                moveTo(0f, 0f)
                horizontalLineToRelative(18f)
                verticalLineToRelative(14f)
                horizontalLineToRelative(-18f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(-2.004f, 13f)
                lineTo(1.957f, 14.737f)
                lineTo(18.09f, 1.889f)
                lineTo(20.179f, -0.693f)
                lineTo(15.943f, -1.273f)
                lineTo(9.363f, 4.263f)
                lineTo(4.067f, 7.994f)
                lineTo(-2.004f, 13f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(-1.462f, 14.217f)
                lineTo(0.556f, 15.225f)
                lineTo(19.429f, -0.933f)
                horizontalLineTo(16.596f)
                lineTo(-1.462f, 14.217f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(20.004f, 13f)
                lineTo(16.043f, 14.737f)
                lineTo(-0.09f, 1.889f)
                lineTo(-2.179f, -0.693f)
                lineTo(2.056f, -1.273f)
                lineTo(8.637f, 4.263f)
                lineTo(13.933f, 7.994f)
                lineTo(20.004f, 13f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(19.869f, 13.873f)
                lineTo(17.851f, 14.882f)
                lineTo(9.815f, 7.964f)
                lineTo(7.432f, 7.191f)
                lineTo(-2.38f, -0.684f)
                horizontalLineTo(0.453f)
                lineTo(10.26f, 7.004f)
                lineTo(12.865f, 7.931f)
                lineTo(19.869f, 13.873f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.985f, 0f)
                horizontalLineTo(7.985f)
                verticalLineTo(6f)
                horizontalLineTo(0f)
                verticalLineTo(8f)
                horizontalLineTo(7.985f)
                verticalLineTo(14f)
                horizontalLineTo(9.985f)
                verticalLineTo(8f)
                horizontalLineTo(18f)
                verticalLineTo(6f)
                horizontalLineTo(9.985f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.485f, 0f)
                horizontalLineTo(11.484f)
                verticalLineTo(4.5f)
                horizontalLineTo(18f)
                verticalLineTo(9.5f)
                horizontalLineTo(11.484f)
                lineTo(11.5f, 14f)
                horizontalLineTo(6.5f)
                lineTo(6.485f, 9.5f)
                horizontalLineTo(0f)
                verticalLineTo(4.5f)
                horizontalLineTo(6.485f)
                verticalLineTo(0f)
                close()
                moveTo(7.985f, 6f)
                horizontalLineTo(0f)
                verticalLineTo(8f)
                horizontalLineTo(7.985f)
                verticalLineTo(14f)
                horizontalLineTo(9.985f)
                verticalLineTo(8f)
                horizontalLineTo(18f)
                verticalLineTo(6f)
                horizontalLineTo(9.985f)
                verticalLineTo(0f)
                horizontalLineTo(7.985f)
                verticalLineTo(6f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFFF50100)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(24.1f, 7.471f)
            lineTo(23.84f, 8.985f)
            lineTo(25.2f, 8.27f)
            lineTo(26.56f, 8.985f)
            lineTo(26.3f, 7.471f)
            lineTo(27.4f, 6.398f)
            lineTo(25.88f, 6.177f)
            lineTo(25.2f, 4.8f)
            lineTo(24.52f, 6.177f)
            lineTo(23f, 6.398f)
            lineTo(24.1f, 7.471f)
            close()
            moveTo(20.1f, 13.071f)
            lineTo(19.84f, 14.585f)
            lineTo(21.2f, 13.87f)
            lineTo(22.56f, 14.585f)
            lineTo(22.3f, 13.071f)
            lineTo(23.4f, 11.998f)
            lineTo(21.88f, 11.778f)
            lineTo(21.2f, 10.4f)
            lineTo(20.52f, 11.778f)
            lineTo(19f, 11.998f)
            lineTo(20.1f, 13.071f)
            close()
            moveTo(23.427f, 19.463f)
            lineTo(23.09f, 21.427f)
            lineTo(24.853f, 20.5f)
            lineTo(26.617f, 21.427f)
            lineTo(26.28f, 19.463f)
            lineTo(27.706f, 18.073f)
            lineTo(25.735f, 17.787f)
            lineTo(24.853f, 16f)
            lineTo(23.972f, 17.787f)
            lineTo(22f, 18.073f)
            lineTo(23.427f, 19.463f)
            close()
            moveTo(26.839f, 14.58f)
            lineTo(27.099f, 13.068f)
            lineTo(26f, 11.997f)
            lineTo(27.518f, 11.776f)
            lineTo(28.198f, 10.4f)
            lineTo(28.877f, 11.776f)
            lineTo(30.395f, 11.997f)
            lineTo(29.296f, 13.068f)
            lineTo(29.556f, 14.58f)
            lineTo(28.198f, 13.866f)
            lineTo(26.839f, 14.58f)
            close()
        }
        path(fill = SolidColor(Color(0xFFF7FCFF))) {
            moveTo(23.84f, 8.985f)
            lineTo(23.643f, 8.951f)
            lineTo(23.575f, 9.35f)
            lineTo(23.933f, 9.162f)
            lineTo(23.84f, 8.985f)
            close()
            moveTo(24.1f, 7.471f)
            lineTo(24.297f, 7.504f)
            lineTo(24.315f, 7.401f)
            lineTo(24.24f, 7.327f)
            lineTo(24.1f, 7.471f)
            close()
            moveTo(25.2f, 8.27f)
            lineTo(25.293f, 8.093f)
            lineTo(25.2f, 8.044f)
            lineTo(25.107f, 8.093f)
            lineTo(25.2f, 8.27f)
            close()
            moveTo(26.56f, 8.985f)
            lineTo(26.467f, 9.162f)
            lineTo(26.825f, 9.35f)
            lineTo(26.757f, 8.951f)
            lineTo(26.56f, 8.985f)
            close()
            moveTo(26.3f, 7.471f)
            lineTo(26.16f, 7.327f)
            lineTo(26.085f, 7.401f)
            lineTo(26.103f, 7.504f)
            lineTo(26.3f, 7.471f)
            close()
            moveTo(27.4f, 6.398f)
            lineTo(27.54f, 6.542f)
            lineTo(27.83f, 6.259f)
            lineTo(27.429f, 6.2f)
            lineTo(27.4f, 6.398f)
            close()
            moveTo(25.88f, 6.177f)
            lineTo(25.701f, 6.266f)
            lineTo(25.747f, 6.36f)
            lineTo(25.851f, 6.375f)
            lineTo(25.88f, 6.177f)
            close()
            moveTo(25.2f, 4.8f)
            lineTo(25.379f, 4.711f)
            lineTo(25.2f, 4.348f)
            lineTo(25.021f, 4.711f)
            lineTo(25.2f, 4.8f)
            close()
            moveTo(24.52f, 6.177f)
            lineTo(24.549f, 6.375f)
            lineTo(24.653f, 6.36f)
            lineTo(24.699f, 6.266f)
            lineTo(24.52f, 6.177f)
            close()
            moveTo(23f, 6.398f)
            lineTo(22.971f, 6.2f)
            lineTo(22.57f, 6.259f)
            lineTo(22.86f, 6.542f)
            lineTo(23f, 6.398f)
            close()
            moveTo(19.84f, 14.585f)
            lineTo(19.643f, 14.551f)
            lineTo(19.575f, 14.95f)
            lineTo(19.933f, 14.762f)
            lineTo(19.84f, 14.585f)
            close()
            moveTo(20.1f, 13.071f)
            lineTo(20.297f, 13.104f)
            lineTo(20.315f, 13.001f)
            lineTo(20.24f, 12.927f)
            lineTo(20.1f, 13.071f)
            close()
            moveTo(21.2f, 13.87f)
            lineTo(21.293f, 13.693f)
            lineTo(21.2f, 13.644f)
            lineTo(21.107f, 13.693f)
            lineTo(21.2f, 13.87f)
            close()
            moveTo(22.56f, 14.585f)
            lineTo(22.467f, 14.762f)
            lineTo(22.825f, 14.95f)
            lineTo(22.757f, 14.551f)
            lineTo(22.56f, 14.585f)
            close()
            moveTo(22.3f, 13.071f)
            lineTo(22.16f, 12.927f)
            lineTo(22.085f, 13.001f)
            lineTo(22.103f, 13.104f)
            lineTo(22.3f, 13.071f)
            close()
            moveTo(23.4f, 11.998f)
            lineTo(23.54f, 12.142f)
            lineTo(23.83f, 11.859f)
            lineTo(23.429f, 11.8f)
            lineTo(23.4f, 11.998f)
            close()
            moveTo(21.88f, 11.778f)
            lineTo(21.701f, 11.866f)
            lineTo(21.747f, 11.96f)
            lineTo(21.851f, 11.975f)
            lineTo(21.88f, 11.778f)
            close()
            moveTo(21.2f, 10.4f)
            lineTo(21.379f, 10.311f)
            lineTo(21.2f, 9.948f)
            lineTo(21.021f, 10.311f)
            lineTo(21.2f, 10.4f)
            close()
            moveTo(20.52f, 11.778f)
            lineTo(20.549f, 11.975f)
            lineTo(20.653f, 11.96f)
            lineTo(20.699f, 11.866f)
            lineTo(20.52f, 11.778f)
            close()
            moveTo(19f, 11.998f)
            lineTo(18.971f, 11.8f)
            lineTo(18.57f, 11.859f)
            lineTo(18.86f, 12.142f)
            lineTo(19f, 11.998f)
            close()
            moveTo(23.09f, 21.427f)
            lineTo(22.893f, 21.393f)
            lineTo(22.824f, 21.793f)
            lineTo(23.183f, 21.604f)
            lineTo(23.09f, 21.427f)
            close()
            moveTo(23.427f, 19.463f)
            lineTo(23.624f, 19.497f)
            lineTo(23.642f, 19.394f)
            lineTo(23.566f, 19.32f)
            lineTo(23.427f, 19.463f)
            close()
            moveTo(24.853f, 20.5f)
            lineTo(24.946f, 20.323f)
            lineTo(24.853f, 20.274f)
            lineTo(24.76f, 20.323f)
            lineTo(24.853f, 20.5f)
            close()
            moveTo(26.617f, 21.427f)
            lineTo(26.524f, 21.604f)
            lineTo(26.882f, 21.793f)
            lineTo(26.814f, 21.393f)
            lineTo(26.617f, 21.427f)
            close()
            moveTo(26.28f, 19.463f)
            lineTo(26.14f, 19.32f)
            lineTo(26.065f, 19.394f)
            lineTo(26.083f, 19.497f)
            lineTo(26.28f, 19.463f)
            close()
            moveTo(27.706f, 18.073f)
            lineTo(27.846f, 18.216f)
            lineTo(28.136f, 17.933f)
            lineTo(27.735f, 17.875f)
            lineTo(27.706f, 18.073f)
            close()
            moveTo(25.735f, 17.787f)
            lineTo(25.556f, 17.875f)
            lineTo(25.602f, 17.969f)
            lineTo(25.706f, 17.984f)
            lineTo(25.735f, 17.787f)
            close()
            moveTo(24.853f, 16f)
            lineTo(25.032f, 15.911f)
            lineTo(24.853f, 15.548f)
            lineTo(24.674f, 15.911f)
            lineTo(24.853f, 16f)
            close()
            moveTo(23.972f, 17.787f)
            lineTo(24f, 17.984f)
            lineTo(24.104f, 17.969f)
            lineTo(24.151f, 17.875f)
            lineTo(23.972f, 17.787f)
            close()
            moveTo(22f, 18.073f)
            lineTo(21.971f, 17.875f)
            lineTo(21.57f, 17.933f)
            lineTo(21.86f, 18.216f)
            lineTo(22f, 18.073f)
            close()
            moveTo(27.099f, 13.068f)
            lineTo(27.296f, 13.101f)
            lineTo(27.314f, 12.998f)
            lineTo(27.238f, 12.924f)
            lineTo(27.099f, 13.068f)
            close()
            moveTo(26.839f, 14.58f)
            lineTo(26.642f, 14.546f)
            lineTo(26.574f, 14.946f)
            lineTo(26.933f, 14.757f)
            lineTo(26.839f, 14.58f)
            close()
            moveTo(26f, 11.997f)
            lineTo(25.971f, 11.799f)
            lineTo(25.57f, 11.857f)
            lineTo(25.86f, 12.14f)
            lineTo(26f, 11.997f)
            close()
            moveTo(27.518f, 11.776f)
            lineTo(27.547f, 11.974f)
            lineTo(27.651f, 11.959f)
            lineTo(27.698f, 11.865f)
            lineTo(27.518f, 11.776f)
            close()
            moveTo(28.198f, 10.4f)
            lineTo(28.377f, 10.311f)
            lineTo(28.198f, 9.948f)
            lineTo(28.018f, 10.311f)
            lineTo(28.198f, 10.4f)
            close()
            moveTo(28.877f, 11.776f)
            lineTo(28.697f, 11.865f)
            lineTo(28.744f, 11.959f)
            lineTo(28.848f, 11.974f)
            lineTo(28.877f, 11.776f)
            close()
            moveTo(30.395f, 11.997f)
            lineTo(30.535f, 12.14f)
            lineTo(30.825f, 11.857f)
            lineTo(30.424f, 11.799f)
            lineTo(30.395f, 11.997f)
            close()
            moveTo(29.296f, 13.068f)
            lineTo(29.157f, 12.924f)
            lineTo(29.081f, 12.998f)
            lineTo(29.099f, 13.101f)
            lineTo(29.296f, 13.068f)
            close()
            moveTo(29.556f, 14.58f)
            lineTo(29.463f, 14.757f)
            lineTo(29.821f, 14.946f)
            lineTo(29.753f, 14.546f)
            lineTo(29.556f, 14.58f)
            close()
            moveTo(28.198f, 13.866f)
            lineTo(28.291f, 13.689f)
            lineTo(28.198f, 13.64f)
            lineTo(28.104f, 13.689f)
            lineTo(28.198f, 13.866f)
            close()
            moveTo(24.037f, 9.018f)
            lineTo(24.297f, 7.504f)
            lineTo(23.903f, 7.437f)
            lineTo(23.643f, 8.951f)
            lineTo(24.037f, 9.018f)
            close()
            moveTo(25.107f, 8.093f)
            lineTo(23.747f, 8.808f)
            lineTo(23.933f, 9.162f)
            lineTo(25.293f, 8.447f)
            lineTo(25.107f, 8.093f)
            close()
            moveTo(26.653f, 8.808f)
            lineTo(25.293f, 8.093f)
            lineTo(25.107f, 8.447f)
            lineTo(26.467f, 9.162f)
            lineTo(26.653f, 8.808f)
            close()
            moveTo(26.103f, 7.504f)
            lineTo(26.363f, 9.018f)
            lineTo(26.757f, 8.951f)
            lineTo(26.497f, 7.437f)
            lineTo(26.103f, 7.504f)
            close()
            moveTo(27.26f, 6.255f)
            lineTo(26.16f, 7.327f)
            lineTo(26.44f, 7.614f)
            lineTo(27.54f, 6.542f)
            lineTo(27.26f, 6.255f)
            close()
            moveTo(25.851f, 6.375f)
            lineTo(27.371f, 6.596f)
            lineTo(27.429f, 6.2f)
            lineTo(25.909f, 5.98f)
            lineTo(25.851f, 6.375f)
            close()
            moveTo(25.021f, 4.889f)
            lineTo(25.701f, 6.266f)
            lineTo(26.059f, 6.089f)
            lineTo(25.379f, 4.711f)
            lineTo(25.021f, 4.889f)
            close()
            moveTo(24.699f, 6.266f)
            lineTo(25.379f, 4.889f)
            lineTo(25.021f, 4.711f)
            lineTo(24.341f, 6.089f)
            lineTo(24.699f, 6.266f)
            close()
            moveTo(23.029f, 6.596f)
            lineTo(24.549f, 6.375f)
            lineTo(24.491f, 5.98f)
            lineTo(22.971f, 6.2f)
            lineTo(23.029f, 6.596f)
            close()
            moveTo(24.24f, 7.327f)
            lineTo(23.14f, 6.255f)
            lineTo(22.86f, 6.542f)
            lineTo(23.96f, 7.614f)
            lineTo(24.24f, 7.327f)
            close()
            moveTo(20.037f, 14.618f)
            lineTo(20.297f, 13.104f)
            lineTo(19.903f, 13.037f)
            lineTo(19.643f, 14.551f)
            lineTo(20.037f, 14.618f)
            close()
            moveTo(21.107f, 13.693f)
            lineTo(19.747f, 14.408f)
            lineTo(19.933f, 14.762f)
            lineTo(21.293f, 14.047f)
            lineTo(21.107f, 13.693f)
            close()
            moveTo(22.653f, 14.408f)
            lineTo(21.293f, 13.693f)
            lineTo(21.107f, 14.047f)
            lineTo(22.467f, 14.762f)
            lineTo(22.653f, 14.408f)
            close()
            moveTo(22.103f, 13.104f)
            lineTo(22.363f, 14.618f)
            lineTo(22.757f, 14.551f)
            lineTo(22.497f, 13.037f)
            lineTo(22.103f, 13.104f)
            close()
            moveTo(23.26f, 11.855f)
            lineTo(22.16f, 12.927f)
            lineTo(22.44f, 13.214f)
            lineTo(23.54f, 12.142f)
            lineTo(23.26f, 11.855f)
            close()
            moveTo(21.851f, 11.975f)
            lineTo(23.371f, 12.196f)
            lineTo(23.429f, 11.8f)
            lineTo(21.909f, 11.58f)
            lineTo(21.851f, 11.975f)
            close()
            moveTo(21.021f, 10.488f)
            lineTo(21.701f, 11.866f)
            lineTo(22.059f, 11.689f)
            lineTo(21.379f, 10.311f)
            lineTo(21.021f, 10.488f)
            close()
            moveTo(20.699f, 11.866f)
            lineTo(21.379f, 10.488f)
            lineTo(21.021f, 10.311f)
            lineTo(20.341f, 11.689f)
            lineTo(20.699f, 11.866f)
            close()
            moveTo(19.029f, 12.196f)
            lineTo(20.549f, 11.975f)
            lineTo(20.491f, 11.58f)
            lineTo(18.971f, 11.8f)
            lineTo(19.029f, 12.196f)
            close()
            moveTo(20.24f, 12.927f)
            lineTo(19.14f, 11.855f)
            lineTo(18.86f, 12.142f)
            lineTo(19.96f, 13.214f)
            lineTo(20.24f, 12.927f)
            close()
            moveTo(23.287f, 21.461f)
            lineTo(23.624f, 19.497f)
            lineTo(23.229f, 19.43f)
            lineTo(22.893f, 21.393f)
            lineTo(23.287f, 21.461f)
            close()
            moveTo(24.76f, 20.323f)
            lineTo(22.997f, 21.25f)
            lineTo(23.183f, 21.604f)
            lineTo(24.946f, 20.677f)
            lineTo(24.76f, 20.323f)
            close()
            moveTo(26.71f, 21.25f)
            lineTo(24.946f, 20.323f)
            lineTo(24.76f, 20.677f)
            lineTo(26.524f, 21.604f)
            lineTo(26.71f, 21.25f)
            close()
            moveTo(26.083f, 19.497f)
            lineTo(26.419f, 21.461f)
            lineTo(26.814f, 21.393f)
            lineTo(26.477f, 19.43f)
            lineTo(26.083f, 19.497f)
            close()
            moveTo(27.567f, 17.93f)
            lineTo(26.14f, 19.32f)
            lineTo(26.419f, 19.607f)
            lineTo(27.846f, 18.216f)
            lineTo(27.567f, 17.93f)
            close()
            moveTo(25.706f, 17.984f)
            lineTo(27.678f, 18.271f)
            lineTo(27.735f, 17.875f)
            lineTo(25.764f, 17.589f)
            lineTo(25.706f, 17.984f)
            close()
            moveTo(24.674f, 16.088f)
            lineTo(25.556f, 17.875f)
            lineTo(25.914f, 17.698f)
            lineTo(25.032f, 15.911f)
            lineTo(24.674f, 16.088f)
            close()
            moveTo(24.151f, 17.875f)
            lineTo(25.032f, 16.088f)
            lineTo(24.674f, 15.911f)
            lineTo(23.792f, 17.698f)
            lineTo(24.151f, 17.875f)
            close()
            moveTo(22.029f, 18.271f)
            lineTo(24f, 17.984f)
            lineTo(23.943f, 17.589f)
            lineTo(21.971f, 17.875f)
            lineTo(22.029f, 18.271f)
            close()
            moveTo(23.566f, 19.32f)
            lineTo(22.14f, 17.93f)
            lineTo(21.86f, 18.216f)
            lineTo(23.287f, 19.607f)
            lineTo(23.566f, 19.32f)
            close()
            moveTo(26.902f, 13.034f)
            lineTo(26.642f, 14.546f)
            lineTo(27.037f, 14.614f)
            lineTo(27.296f, 13.101f)
            lineTo(26.902f, 13.034f)
            close()
            moveTo(25.86f, 12.14f)
            lineTo(26.959f, 13.211f)
            lineTo(27.238f, 12.924f)
            lineTo(26.14f, 11.853f)
            lineTo(25.86f, 12.14f)
            close()
            moveTo(27.49f, 11.578f)
            lineTo(25.971f, 11.799f)
            lineTo(26.029f, 12.194f)
            lineTo(27.547f, 11.974f)
            lineTo(27.49f, 11.578f)
            close()
            moveTo(28.018f, 10.311f)
            lineTo(27.339f, 11.688f)
            lineTo(27.698f, 11.865f)
            lineTo(28.377f, 10.488f)
            lineTo(28.018f, 10.311f)
            close()
            moveTo(29.056f, 11.688f)
            lineTo(28.377f, 10.311f)
            lineTo(28.018f, 10.488f)
            lineTo(28.697f, 11.865f)
            lineTo(29.056f, 11.688f)
            close()
            moveTo(30.424f, 11.799f)
            lineTo(28.905f, 11.578f)
            lineTo(28.848f, 11.974f)
            lineTo(30.366f, 12.194f)
            lineTo(30.424f, 11.799f)
            close()
            moveTo(29.436f, 13.211f)
            lineTo(30.535f, 12.14f)
            lineTo(30.256f, 11.853f)
            lineTo(29.157f, 12.924f)
            lineTo(29.436f, 13.211f)
            close()
            moveTo(29.753f, 14.546f)
            lineTo(29.493f, 13.034f)
            lineTo(29.099f, 13.101f)
            lineTo(29.359f, 14.614f)
            lineTo(29.753f, 14.546f)
            close()
            moveTo(28.104f, 14.043f)
            lineTo(29.463f, 14.757f)
            lineTo(29.649f, 14.403f)
            lineTo(28.291f, 13.689f)
            lineTo(28.104f, 14.043f)
            close()
            moveTo(26.933f, 14.757f)
            lineTo(28.291f, 14.043f)
            lineTo(28.104f, 13.689f)
            lineTo(26.746f, 14.403f)
            lineTo(26.933f, 14.757f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun NewZealandPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.NewZealand,
            contentDescription = "New Zealand Flag"
        )
    }
}
